import { createContext, ReactNode, useContext } from 'react';
import { useTreatments, SplitContext } from '@splitsoftware/splitio-react';
import { SplitioProvider } from '../SplitioProvider';

type Props = {
  children: ReactNode;
  splitName: string;
};

function SplitTestUnwrapped({ splitName, children }: Props) {
  const { isReady, isReadyFromCache, isTimedout } = useContext(SplitContext);

  const treatments = useTreatments([splitName]);

  const { treatment } = treatments?.[splitName] || {};
  return (
    <SplitTestContext.Provider
      value={{
        splitName,
        isReady: isReady || isReadyFromCache || isTimedout,
        treatment,
      }}
    >
      {children}
    </SplitTestContext.Provider>
  );
}

const SplitTestContext = createContext({
  splitName: '',
  isReady: false,
  treatment: '',
});

export const useSplitTestContext = () => {
  const context = useContext(SplitTestContext);
  return context;
};

export function SplitTest(props: Props) {
  return (
    <SplitioProvider>
      <SplitTestUnwrapped {...props} />
    </SplitioProvider>
  );
}
